import fonts from 'common/constants/fonts'
import { WebsiteStylesInterface } from 'src/shared/types/website-settings-types'
export const fontProviders = {
  google: 'google',
  custom: 'custom',
  safe: 'safe',
  inherit: 'inherit',
} as const

export type FontProviderType =
  (typeof fontProviders)[keyof typeof fontProviders]

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const detectFontProvider = (fontFamily: string): FontProviderType => {
  const normalizedFontFamily = fontFamily.trim().toLowerCase()

  if (!fontFamily || fontFamily === 'inherit') {
    return fontProviders.inherit
  }

  if (fonts.safe.find(safeFF => safeFF === fontFamily)) {
    return fontProviders.safe
  }

  if (
    fonts.google.some(
      googleFontFamily =>
        googleFontFamily.trim().toLowerCase() === normalizedFontFamily,
    )
  ) {
    return fontProviders.google
  }

  return fontProviders.custom
}

const removeFontFile = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(item => removeFontFile(item))
  }

  if (!isRecord(value)) {
    return value
  }

  const result: Record<string, unknown> = {}
  let fontFamily: string | undefined
  let fontFileId: number | null | undefined
  let fontFileIdFromFile: number | null | undefined
  for (const [key, entry] of Object.entries(value)) {
    if (key === 'fontFile') {
      if (isRecord(entry) && typeof entry.id === 'number') {
        fontFileIdFromFile = entry.id
      }
      continue
    }
    if (key === 'fontFamily' && typeof entry === 'string') {
      fontFamily = entry
    }
    if (key === 'fontFileId') {
      fontFileId = typeof entry === 'number' ? entry : null
    }
    result[key] = removeFontFile(entry)
  }

  if (typeof fontFamily === 'string' && fontFamily.trim()) {
    result.fontProvider = detectFontProvider(fontFamily)
  }

  if (
    !fontFileId &&
    result.fontProvider === fontProviders.custom &&
    fontFileIdFromFile
  ) {
    result.fontFileId = fontFileIdFromFile
  }

  return result
}

export const transformWebsiteStylesForApi = (
  styles: WebsiteStylesInterface,
) => {
  return removeFontFile(styles) as WebsiteStylesInterface
}
